import React, { useState } from 'react';
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '70%',
        padding: '20px 0',
        '& >*': {
            width: '100%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            padding: '10px 0'
        }
    }
}));

export const EmailInput = ({ value, onComplete, ...restProps }) => {
    const classes = useStyles();
    const [error, setError] = useState(false)
    const [errorText, setErrorText] = useState(false)
    const [emailVal, setEmailVal] = useState('')

    const onChange = (event) => {
        setEmailVal(event.target.value)
        onComplete(event)
        handleError()
        const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        if (regex.test(event.target.value)) {
            setError(false)
            setErrorText('')
        } else {
            setError(true)
            setErrorText('This is not a valid Email Address')
        }
    }

    const handleError = () => {
        const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        if (!regex.test(emailVal)) {
            setError(true)
            setErrorText('This is not a valid Email Address')
        } else {
            setError(false)
            setErrorText('')
        }
    }
    return (
        <FormControl className={classes.formControl}>
            <TextField
                label={'Email Address'}
                name="email"
                {...restProps}
                error={error}
                onChange={onChange}
                helperText={errorText}
            />
        </FormControl>
    )
}
